import type { SliceTemplateProps } from '@yoweb/prismic-slicemachine/slices/slicesTypes';
import AccordionColorGroupsSectionSlice, {
  AccordionColorGroupsSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/AccordionColorGroupsSectionSlice';
import ColoredCtaSectionSlice, {
  ColoredCtaSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/ColoredCtaSectionSlice';
import AppDownloadCtaSectionSlice, {
  AppDownloadCtaSectionSliceType,
} from '@yoweb/prismic-slicemachine/slices/AppDownloadCtaSectionSlice';
import ImageHeaderSlice, {
  ImageHeaderSliceType,
} from '@yoweb/prismic-slicemachine/slices/ImageHeaderSlice';
import SeoSlice, { SeoSliceType } from '@yoweb/prismic-slicemachine/slices/SeoSlice';

export const ThingsWeDoTemplate = ({ slice }: SliceTemplateProps): JSX.Element | null => {
  switch (slice.slice_type) {
    case SeoSliceType:
      return <SeoSlice slice={slice} />;

    case ImageHeaderSliceType:
      return <ImageHeaderSlice data-testid="image-header-slice" slice={slice} />;

    case AccordionColorGroupsSectionSliceType:
      return (
        <AccordionColorGroupsSectionSlice
          data-testid="accordion-color-groups-slice"
          slice={slice}
        />
      );

    case ColoredCtaSectionSliceType:
      return <ColoredCtaSectionSlice atBottom backgroundColor="sky" slice={slice} />;

    case AppDownloadCtaSectionSliceType:
      return <AppDownloadCtaSectionSlice backgroundColor="sky" slice={slice} />;

    default:
      return null;
  }
};
